export class AuthConstants {
	public static readonly TOKEN = 'token'
};